import { useContext } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AuthContext } from "../../context/AuthContext";
import { signIn } from "../../services/authService";
import { normalizeEmail } from "../../utils/inputFormatters";
import styles from "../signin/SignIn.module.css";

const validationSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Informe um e-mail válido")
    .required("Informe o e-mail"),
  password: Yup.string()
    .min(6, "A senha deve ter pelo menos 6 caracteres")
    .required("Informe a senha"),
});

function SignIn() {
  const { setAuthUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const response = await signIn(values);
        if (response.success) {
          // Store JWT token in localStorage for session management
          setAuthUser(response.user);
          navigate("/homepage", { replace: true });
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Não foi possível entrar."
        );
      }
    },
  });

  return (
    <div className={styles.signIn}>
      <aside className={styles.welcomePanel} aria-hidden="true">
        <div className={styles.welcomeContent}>
          <span className={styles.welcomeBadge}>Sua comunidade, do seu jeito</span>
          <h2>Compartilhe momentos. Crie conexões.</h2>
          <p>Um espaço leve para acompanhar quem faz parte da sua história.</p>
        </div>
      </aside>
      <div className={styles.signInFormDescription}>
        <div className={styles.logoNameDetail}>
          <div className={styles.logo}>
            <img src="/logopreta.png" alt="weDress" />
          </div>
          <p className={styles.formIntro}>Entre para continuar</p>
        </div>
        <div className={styles.signInForm}>
          <form onSubmit={formik.handleSubmit}>
            <div className={styles.signInFormContant}>
              <label htmlFor="email">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="E-mail"
                  autoComplete="email"
                  onChange={formik.handleChange}
                  onBlur={(event) => {
                    formik.setFieldValue(
                      "email",
                      normalizeEmail(event.target.value)
                    );
                    formik.handleBlur(event);
                  }}
                  value={formik.values.email}
                  className={
                    formik.touched.email && formik.errors.email ? "error" : ""
                  }
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="error-message">{formik.errors.email}</div>
                )}
              </label>

              <label htmlFor="password">
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Senha"
                  autoComplete="current-password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                  className={
                    formik.touched.password && formik.errors.password
                      ? "error"
                      : ""
                  }
                />
                {formik.touched.password && formik.errors.password && (
                  <div className="error-message">{formik.errors.password}</div>
                )}
              </label>
            </div>
            <div className={styles.submitButton}>
              <button type="submit" disabled={formik.isSubmitting}>
                {formik.isSubmitting ? "Entrando..." : "Entrar"}
              </button>
            </div>
          </form>
        </div>
        <div className={styles.signInRedirect}>
          <p>
            Não tem uma conta? <Link to="/signUp">Cadastre-se</Link>
          </p>
          <p><Link to="/termos">Termos de uso e privacidade</Link></p>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
